<template>
<div class="vpn-page">
  <HeadNav />
  <main class="doc-page">
    <h1>Common VPN Problems and How to Fix Them</h1>
    <DocBlocks :blocks="problemBlocks" />
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss'
import HeadNav from '@/components/HeadNav.vue'
import DocBlocks from '@/components/myvpnbook/DocBlocks.vue'
import { problemBlocks } from '@/data/myvpnbookDocPages'

export default {
  name: 'CommonVpnProblems',
  components: { HeadNav, DocBlocks },
  data() {
    return { problemBlocks }
  },
  mounted() {
    if (typeof document !== 'undefined') document.body.classList.add('vpn-site')
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') document.body.classList.remove('vpn-site')
  },
}
</script>

<style lang="scss" scoped>
.doc-page {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 40px 0 72px;
}

h1 {
  margin: 0 0 16px;
  font-size: clamp(32px, 4vw, 44px);
  line-height: 1.2;
}
</style>
